export function testFunction() {
    console.log('Reached test function successfully.');
}
